export default __webpack_public_path__ + "static/media/image3.ae995429.jpg";